import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  PayItemConnection,
  useConnectionsContext,
} from '../../ConnectionsContext'
import { useCreateGoogleSheetPayItemConnectionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import CreateBody from './CreateBody'
import { CreateBodyValues } from './CreateBody/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<PayItemConnection> {
  const { projectId } = useProjectContext()
  const { refetch } = useConnectionsContext()
  const [createGoogleSheet] = useCreateGoogleSheetPayItemConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createGoogleSheetPayItemConnection: {
        googleSheet: {
          connection: { name },
        },
      },
    }) => simpleCreateNotification(name ?? 'Google Sheet Connection'),
  })
  return {
    entity: 'Connection',
    permission: Permission.CreatePayItemConnection,
    modal: {
      type: 'simple',
      body: <CreateBody />,
      onOk: async ({ name, group, googleSheet }: CreateBodyValues) => {
        let promise
        if (!!googleSheet) {
          const { documentId, sheetId, url, ...rest } = googleSheet
          if (url || (documentId && sheetId))
            promise = createGoogleSheet({
              variables: {
                input: {
                  ...rest,
                  groupId: group?.value as string,
                  url,
                  documentId,
                  sheetId: sheetId ? parseInt(sheetId) : undefined,
                  name,
                  projectId,
                },
              },
            })
        }
        if (promise) {
          await promise
          refetch()
        }
      },
    },
  }
}
